import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

/**
 * F-B1 · 采购订单（动态路由，登录后用户可见）
 *
 * 路径：/purchase-order/index
 * 父路由：BasicLayout（保留侧边栏 / 顶栏）
 */
const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:clipboard-text-outline',
      order: 2,
      title: '采购管理',
      keepAlive: true,
    },
    name: 'PurchaseOrderBase',
    path: '/purchase-order',
    redirect: '/purchase-order/index',
    children: [
      {
        component: () => import('#/views/workspace/purchase-order/index.vue'),
        meta: {
          icon: 'mdi:cart-outline',
          title: '采购订单',
          keepAlive: true,
        },
        name: 'PurchaseOrder',
        path: 'index',
      },
    ],
  },
];

export default routes;
